function isCurrentRule(rule, now = Date.now()) {
  return Boolean(rule?.enabled) && (!rule.expiresAtUtc || Date.parse(rule.expiresAtUtc) > now);
}

function classifyAccessValue(input) {
  const value = String(input || '').trim().toLowerCase();
  if (!value || value.length > 254) return null;
  if (value.includes('@')) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return null;
    return { ruleType: 'email', value };
  }
  if (value.length > 253 || !value.includes('.') || !value.split('.').every(label => label.length <= 63 && /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(label))) return null;
  return { ruleType: 'domain', value };
}

function formatAccessEventTime(value) {
  const formatted = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(value instanceof Date ? value : new Date(value));
  return formatted.replace(', ', ' at ');
}

function summarizeBranchAccess(rules, now = Date.now()) {
  const current = (rules || []).filter(rule => rule.ruleType !== 'company' && isCurrentRule(rule, now));
  const denied = new Set(current.filter(rule => rule.effect === 'deny').map(rule => `${rule.ruleType}:${rule.value}`));
  const allowed = current
    .filter(rule => rule.effect === 'allow' && !denied.has(`${rule.ruleType}:${rule.value}`))
    .sort((left, right) => left.value.localeCompare(right.value));
  return {
    enabled: Boolean((rules || []).find(rule => rule.ruleType === 'company')?.enabled),
    domains: allowed.filter(rule => rule.ruleType === 'domain'),
    emails: allowed.filter(rule => rule.ruleType === 'email')
  };
}

module.exports = { classifyAccessValue, formatAccessEventTime, isCurrentRule, summarizeBranchAccess };
